import React from "react"
import { PhotoProvider, PhotoConsumer } from "react-photo-view"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Slider from "react-slick"
import ArrowLeftIcon from "../../../../icons/arrow-left.svg"
import classNames from "classnames"
import styled from "@emotion/styled"

const CarouselVariant = ({ images, lightbox }) => {
  const imagesLength = images?.length
  const slickSettings = {
    infinite: false,
    slidesToShow: 1,
    speed: 500,
    rows: 1,
    dots: true,
    slidesPerRow: 1,
  }
  return lightbox ? (
    <PhotoProvider>
      <Slider
        {...slickSettings}
        arrows={true}
        prevArrow={<ArrowLeft />}
        nextArrow={<ArrowRight imagesLength={imagesLength} />}
        className=" mx-auto"
      >
        {images &&
          images?.map((image, index) => {
            const gatsbyImage =
              image?.carouselImage &&
              getImage(image?.carouselImage?.gatsbyImage)
            if (!gatsbyImage) {
              return null
            }
            return (
              <PhotoConsumer
                key={index}
                src={gatsbyImage?.images?.fallback?.src}
              >
                <div className="relative flex cursor-pointer justify-center focus:outline-none">
                  {/* <div
                    className="relative z-30 overflow-hidden bg-cover bg-no-repeat"
                    // style={{ backgroundPosition: "50%" }}
                  > */}
                  <GatsbyImage
                    alt={image?.altText || ""}
                    image={gatsbyImage}
                    className="relative h-full w-full"
                  />
                  {/* </div> */}
                </div>
              </PhotoConsumer>
            )
          })}
      </Slider>
    </PhotoProvider>
  ) : (
    <Slider
      {...slickSettings}
      arrows={true}
      prevArrow={<ArrowLeft />}
      nextArrow={<ArrowRight imagesLength={imagesLength} />}
      className=" mx-auto"
    >
      {images &&
        images?.map((image, index) => {
          const gatsbyImage =
            image?.carouselImage && getImage(image?.carouselImage?.gatsbyImage)
          if (!gatsbyImage) {
            return null
          }
          return (
            <div
              key={index}
              className="relative flex justify-center focus:outline-none"
            >
              <div
                className="relative z-30 overflow-hidden bg-cover bg-no-repeat"
                style={{ backgroundPosition: "50%" }}
              >
                <GatsbyImage
                  alt={image?.altText || ""}
                  image={gatsbyImage}
                  className="block h-full"
                />
              </div>
            </div>
          )
        })}
    </Slider>
  )
}

export default CarouselVariant

const ArrowLeft = ({ next = false, ...rest }) => {
  const { currentSlide } = rest
  return (
    <ArrowContainer
      {...rest}
      className={classNames(
        "absolute left-0 top-0 bottom-0 z-50 h-full px-[15px] md:px-[50px]",
        currentSlide === 0 && "hidden"
      )}
    >
      <ArrowLeftIcon className="relative  h-[18px] w-[10px] md:h-[32px] md:w-[18px] " />
    </ArrowContainer>
  )
}

const ArrowRight = ({ next = false, imagesLength, ...rest }) => {
  const { currentSlide } = rest
  return (
    <ArrowContainer
      {...rest}
      className={classNames(
        "absolute right-0 top-0 bottom-0 z-50 h-full px-[15px] md:px-[50px]",
        currentSlide === imagesLength - 1 && "hidden"
      )}
    >
      <ArrowLeftIcon className="relative  h-[18px] w-[10px] rotate-180 md:h-[32px] md:w-[18px]" />
    </ArrowContainer>
  )
}

const ArrowContainer = styled.button`
  :hover {
    svg {
      path {
        fill: #585e65;
      }
    }
  }
  svg {
    path {
      fill: #e9e9e9;
    }
  }
`
